import { render, staticRenderFns } from "./TenderClue.vue?vue&type=template&id=4973a5c1&scoped=true&"
import script from "./TenderClue.vue?vue&type=script&lang=js&"
export * from "./TenderClue.vue?vue&type=script&lang=js&"
import style0 from "./TenderClue.vue?vue&type=style&index=0&id=4973a5c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973a5c1",
  null
  
)

export default component.exports